import { FC, ReactNode } from "react"

interface Props {
  label: string
  value: ReactNode
  /** Swatch colour when the figure doubles as a legend entry. */
  color?: string
}

/** One labelled number in a panel footer. */
const StatsFigure: FC<Props> = ({ label, value, color }) => (
  <div className="min-w-0">
    <dt className="flex items-center gap-1.5 text-xs leading-4 text-slate-500">
      {color && (
        <span
          aria-hidden="true"
          className="h-2 w-2 shrink-0 rounded-sm"
          style={{ backgroundColor: color }}
        />
      )}
      <span className="truncate">{label}</span>
    </dt>
    <dd className="mt-0.5 text-base font-semibold leading-6 tabular-nums text-base-dark">
      {value}
    </dd>
  </div>
)

export default StatsFigure
